import "tom-select"
import {DropdownInputPlugin} from "web-ui/tom-select/dropdown-input-plugin"
import {DropdownPlacementPlugin} from "web-ui/tom-select/dropdown-placement-plugin"
import {DropdownScrollPlugin} from "web-ui/tom-select/dropdown-scroll-plugin"
import {DropdownOpenPlugin} from "web-ui/tom-select/dropdown-open-plugin"
import {DropdownCloseOnScrollPlugin} from "web-ui/tom-select/dropdown-close-on-scroll-plugin"
import {SubmitFormPlugin} from "web-ui/tom-select/submit-form-plugin"
import {TurboMorphSyncPlugin} from "web-ui/tom-select/turbo-morph-sync-plugin"
import {ClearButtonPlugin} from "web-ui/tom-select/clear-button-plugin"
import {AddOptionPlugin} from "web-ui/tom-select/add-option-plugin"
import {DestroyPlugin} from "web-ui/tom-select/destroy-plugin"
import {ChecklistOptionsPlugin} from "web-ui/tom-select/checklist-options-plugin"
import {RemoveButtonPlugin} from "web-ui/tom-select/remove-button-plugin"

TomSelect.define("dropdown_input", DropdownInputPlugin)
TomSelect.define("dropdown_placement", DropdownPlacementPlugin)
TomSelect.define("dropdown_scroll", DropdownScrollPlugin)
TomSelect.define("dropdown_open", DropdownOpenPlugin)
TomSelect.define("dropdown_close_on_scroll", DropdownCloseOnScrollPlugin)
TomSelect.define("submit_form", SubmitFormPlugin)
TomSelect.define("turbo_morph_sync", TurboMorphSyncPlugin)
TomSelect.define("clear_button", ClearButtonPlugin)
TomSelect.define("add_option", AddOptionPlugin)
TomSelect.define("destroy", DestroyPlugin)
TomSelect.define("checklist_options", ChecklistOptionsPlugin)
TomSelect.define("remove_button", RemoveButtonPlugin)
